﻿import React, { useCallback } from 'react';

import { GMetrixInput } from 'components/GMetrixInput/GMetrixInput';
import { useIntl } from 'react-intl';

import 'components/KendoPostSearch/kendoPostSearch.scss';

enum FilterLocation {
    StudentSearch = 1,
    GroupSearch = 2,
    TransactionSearch = 3,
    TransactionPerformanceSearch = 4,
    TransactionActivitySearch = 5,
    InstructorSearch = 6,
    FeatureFlagSearch = 7,
    FeatureRingManageUser = 8,
    PartnerSearch = 9,
    LicenseSearch = 10,
    UserSearch = 11,
    OrderSearch = 12
}

interface KendoPostSearchProps {
    autoFocus?: boolean;
    className?: string;
    isPostFiltering?: boolean;
    placeholder?: string;
    preSearchOnClick?: () => void;
    searchTerm: string;
    setSearchTerm: (newTerm: string) => void;
}

function KendoPostSearchComponent({
    autoFocus = true,
    isPostFiltering = true,
    placeholder,
    searchTerm,
    setSearchTerm
}: KendoPostSearchProps) {

    const { formatMessage } = useIntl();

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {

        setSearchTerm(e.target.value);

    }, [setSearchTerm]);

    const resolvedPlaceholder = placeholder ?? (() => {

        const pathname = typeof window !== 'undefined' ? window.location.pathname.toLowerCase() : '';

        if (pathname.includes('student')) return 'Search by name, email, access code...';
        if (pathname.includes('access_code') || pathname.includes('access_codes') || pathname.includes('accesscodes') || pathname.includes('access codes')) return 'Search access codes...';
        if (pathname.includes('classroom') || pathname.includes('group')) return 'Search classrooms...';
        if (pathname.includes('partner')) return 'Search partners...';
        if (pathname.includes('license')) return 'Search licenses...';
        if (pathname.includes('order')) return 'Search orders...';
        if (pathname.includes('featureflag') || pathname.includes('feature_flag')) return 'Search feature flags...';
        if (pathname.includes('instructor')) return 'Search instructors...';

        return !isPostFiltering ? formatMessage({ id: 'search_by_name_username_or_email.aa07a037', defaultMessage: 'Search By Name, Username, or Email' }) : formatMessage({ id: 'search.0ab06b2c', defaultMessage: 'Search' });

    })();

    return (
        <>
            <GMetrixInput
                autoFocus={autoFocus}
                className="w-100"
                onChange={handleChange}
                placeholder={resolvedPlaceholder}
                value={searchTerm}
            />
        </>
    );

}

const KendoPostSearch = React.memo(KendoPostSearchComponent);
KendoPostSearch.displayName = 'KendoPostSearch';

export { KendoPostSearch };
